<tt-card
    *ngIf="!hidden && activeStep as active"
    ttAccordion
    [ttHeading]="active.step_name"
    [ttTranslateHeading]="false"
    [ttIcon]="'fas ' + getStepIcon(active)"
>
    <ul class="steps">
        <li *ngFor="let step of steps">
            <span class="fas fa-fw" [ngClass]="getStepIcon(step)"></span>
            {{ step.step_name }}
        </li>
    </ul>
</tt-card>
